module.exports = {"menuNameSearch":"菜单名称搜索","searchResultTotal":"共{count}条搜索结果","noData":"暂无数据","quickCloseTab":"快捷关闭标签","closeCurrentTab":"关闭当前标签","closeAllTab":"关闭全部标签","closeOtherTab":"关闭其他标签","closeAllConfirm":"将关闭已打开的全部页签, 是否继续?","closeOtherConfirm":"将关闭其他全部页签, 是否继续?","confirm":"确定","cancel":"取消","homePage":"首页","call":"呼叫"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/tabBar.json
// module id = dij0
// module chunks = 1